import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import ContainerPublic from '../base/ContainerPublic'
import { useToast } from '../controls/Toast/ToastService'
import { MdErrorOutline } from 'react-icons/md'
import { GetAll } from '../../configurations/crud/stateCrud'
import * as cityCrud from '../../configurations/crud/cityCrud'
import { GetByCityWithActiveCenter } from '../../configurations/crud/opdCentersCrud'
import { useFormik } from 'formik'
import { FaHospital, FaUserDoctor, FaLockOpen, FaMapLocationDot } from "react-icons/fa6";
import { IsMobileEnv, PUBLIC_PAGE_SIZE } from '../../configurations/initUrls'
import { SearchRandomUsers, SearchUserByCity } from '../../configurations/crud/applicationUserCrud'
import * as yup from 'yup'
import GlobalPaging from '../controls/GlobalPaging'
import Footer from '../base/Footer'
import { IoLocation, IoClose } from "react-icons/io5";
import { FiSearch, FiPlus } from "react-icons/fi";
import useGlobalLoader from '../../configurations/useGlobalLoader'
import LoadingContainer from '../controls/LoadingContainer'
import Team from './Team'
import DoctorsCard from '../controls/DoctorsCard'
import Pricing from './Pricing'
import FabToggle from '../base/FabToggle'
import useAuth from '../../configurations/auth/publicUsers/useAuth'
import PublicUserMenu from './publicUsers/PublicUserMenu'
import QuickPick from '../controls/QuickPick'

export default function Home() {
    const { start, end } = useGlobalLoader()
    const [lodingStateCrud, setLodingStateCrud] = useState(false)
    const [stateData, setStateData] = useState([])
    const [lodingCityCrud, setLodingCityCrud] = useState(false)
    const [cityData, setCityData] = useState([]);
    const [loding, setLoding] = useState(false);
    const [centerData, setCenterData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [searchCount, setSearchCount] = useState(1);
    const [showName, setShowName] = useState(false);
    const toast = useToast()
    const { authentication } = useAuth()

    const initSearch = {
        stateId: undefined,
        cityId: undefined,
        isCenter: 0,
        searchTerm: "",
        pageNo: 0,
        pageSize: PUBLIC_PAGE_SIZE,
    }
    const schemaSearch = yup.object().shape({
        stateId: yup.string().required("Please select state."),
        cityId: yup.string().required("Please select city."),
    })
    const { values, setValues, handleBlur, handleSubmit, handleChange, errors, touched, isValid } = useFormik({
        initialValues: initSearch,
        validationSchema: schemaSearch,
        onSubmit() {
            setValues(pre => ({ ...pre, pageNo: 1 }))
            setSearchCount(pre => pre + 1)
        }
    })

    useEffect(() => { GetStates(); getDoctorsRandom() }, [])

    useEffect(() => {
        setValues({ ...values, pageNo: 0 })
        setUserData([]); setCenterData([]); setPagingData(); setLastPage(1)
    }, [values.isCenter])

    useEffect(() => { if (values.stateId) GetCities(values.stateId) }, [values.stateId])

    useEffect(() => {
        if (values.pageNo > 0)
            if (values.isCenter == 1) { getCenters(values); setUserData([]) }
            else { getDoctors(values); setCenterData([]) }
    }, [values.pageNo, searchCount])

    const GetStates = () => {
        setLodingStateCrud(true); start()
        GetAll().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) setStateData(mdata.data)
            else { setStateData([]); toast.open(mdata.result.message, <MdErrorOutline />, "danger") }
            setLodingStateCrud(false); end()
        }).catch(() => { setStateData([]); setLodingStateCrud(false); end(); toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000) })
    }

    const GetCities = (id) => {
        setLodingCityCrud(true); start()
        cityCrud.GetAll(id).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) setCityData(mdata.data)
            else setCityData([])
            setLodingCityCrud(false); end()
        }).catch(() => { setCityData([]); setLodingCityCrud(false); end(); toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000) })
    }

    const getDoctors = (val) => {
        setLoding(true); start()
        SearchUserByCity({ PageNo: val.pageNo, PageSize: val.pageSize, SearchTerm: val.searchTerm, CityId: val.cityId }).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) { setUserData(mdata.data); setPagingData(mdata.paging); setLastPage(mdata.paging.pageCount) }
            else { setPagingData(); setLastPage(1); setUserData([]); toast.open(mdata.result.message, <MdErrorOutline />, "danger") }
            setLoding(false); end()
        }).catch(() => { setPagingData(); setLastPage(1); setUserData([]); setLoding(false); end(); toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000) })
    }

    const getDoctorsRandom = () => {
        setLoding(true); start()
        SearchRandomUsers({ count: 6 }).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) setUserData(mdata.data); else setUserData([])
            setLoding(false); end()
        }).catch(() => { setUserData([]); setLoding(false); end(); toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000) })
    }

    const getCenters = (val) => {
        setLoding(true); start()
        GetByCityWithActiveCenter({ PageNo: val.pageNo, PageSize: val.pageSize, SearchTerm: val.searchTerm, CityId: val.cityId }).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) { setCenterData(mdata.data); setPagingData(mdata.paging); setLastPage(mdata.paging.pageCount) }
            else { setPagingData(); setLastPage(1); setCenterData([]); toast.open(mdata.result.message, <MdErrorOutline />, "danger") }
            setLoding(false); end()
        }).catch(() => { setPagingData(); setLastPage(1); setCenterData([]); setLoding(false); end(); toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000) })
    }

    const OnPageChange = (e) => {
        const { value } = e.target;
        setValues(pre => ({ ...pre, pageNo: value }))
    }

    // ---- options for QuickPick ----
    const stateOptions = useMemo(() => stateData.map(s => ({ value: s.id, label: `${s.name} (${s.shortName})` })), [stateData])
    const cityOptions = useMemo(() => cityData.map(c => ({ value: c.id, label: `${c.name} (${c.shortName})` })), [cityData])

    const onState = (v) => setValues(pre => ({ ...pre, stateId: v, cityId: undefined }))
    const onCity = (v) => setValues(pre => ({ ...pre, cityId: v }))

    const segActive = "flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-white shadow-soft text-brand-700 transition"
    const segIdle = "flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-gray-500 hover:text-gray-700 transition"

    return (
        <ContainerPublic>
            <div className="min-h-screen flex flex-col text-gray-800 bg-slate-100">
                {/* ---- Navbar ---- */}
                <div className="fixed w-full z-40 bg-white/90 backdrop-blur-xl border-b border-gray-100 shadow-soft py-2.5 pe-4 flex gap-2 justify-between items-center">
                    <Link to="/" className='ms-3 flex items-center'>
                        <img alt="Doctora OPD" src="/assets/images/logo.svg" className="h-7 sm:h-8 w-auto" />
                    </Link>
                    <div className='flex items-center'>
                        {authentication.isLogin ?
                            <PublicUserMenu />
                            :
                            <Link to="/login">
                                <button className="group relative px-5 py-2 rounded-xl bg-gradient-to-b from-brand-400 to-brand-500 shadow-brand hover:brightness-105 text-white transition duration-300 active:scale-95">
                                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition duration-300">
                                        <FaLockOpen />
                                    </span>
                                    <span className="group-hover:ml-5 transition-all duration-300 font-semibold">Login</span>
                                </button>
                            </Link>}
                    </div>
                </div>
                <div className='pt-[56px]'></div>

                {/* ---- Hero + search ---- */}
                <section className="relative overflow-hidden bg-gradient-to-br from-brand-500 via-brand-500 to-ink-900 px-4 sm:px-6 lg:px-20 pt-7 pb-20 text-center">
                    <div className="absolute -top-24 -right-20 h-72 w-72 rounded-full bg-white/10 blur-2xl" />
                    <div className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-brand-300/20 blur-2xl" />
                    <h1 className="relative font-display text-xl sm:text-3xl font-extrabold text-white leading-tight animate-fade-up">
                        Find doctors & OPD centers near you
                    </h1>
                    <p className="relative text-xs sm:text-base text-white/85 max-w-xl mx-auto mt-2 font-medium animate-fade-up">
                        Digital OPD to connect with doctors, manage schedules, and simplify healthcare.
                    </p>
                </section>

                {/* floating search card */}
                <div className="px-4 -mt-14 relative z-10">
                    <form onSubmit={handleSubmit} className="mx-auto w-full max-w-2xl card-surface p-4 sm:p-5 animate-fade-up">
                        {/* Doctor / Center segmented toggle */}
                        <div className="inline-flex w-full sm:w-72 p-1 bg-gray-100 rounded-xl mb-4">
                            <button type="button" onClick={() => setValues({ ...values, isCenter: 0 })} className={values.isCenter == 0 ? segActive : segIdle}>
                                <FaUserDoctor /> Doctor
                            </button>
                            <button type="button" onClick={() => setValues({ ...values, isCenter: 1 })} className={values.isCenter == 1 ? segActive : segIdle}>
                                <FaHospital /> Center
                            </button>
                        </div>

                        {/* Step guide: 1 State -> 2 City -> 3 Search */}
                        <div className="flex items-center gap-2 mb-4">
                            <Step n={1} label="State" done={!!values.stateId} active={!values.stateId} />
                            <span className="flex-1 h-px bg-gray-200" />
                            <Step n={2} label="City" done={!!values.cityId} active={!!values.stateId && !values.cityId} />
                            <span className="flex-1 h-px bg-gray-200" />
                            <Step n={3} label="Search" done={false} active={isValid} />
                        </div>

                        {/* State + City chips */}
                        <div className="grid sm:grid-cols-2 gap-4 mb-4 text-left">
                            <div>
                                {lodingStateCrud
                                    ? <div className="rounded-2xl border border-gray-200 p-3 space-y-2"><div className="h-4 w-16 skeleton" /><div className="flex gap-2"><div className="h-8 w-20 skeleton rounded-full" /><div className="h-8 w-24 skeleton rounded-full" /></div></div>
                                    : <QuickPick label="State" color="emerald" Icon={<FaMapLocationDot />} options={stateOptions} value={values.stateId} onChange={onState} />}
                                {errors.stateId && touched.stateId && <p className='mt-1 text-red-500 text-xs'>{errors.stateId}</p>}
                            </div>
                            <div>
                                {lodingCityCrud
                                    ? <div className="rounded-2xl border border-gray-200 p-3 space-y-2"><div className="h-4 w-16 skeleton" /><div className="flex gap-2"><div className="h-8 w-20 skeleton rounded-full" /><div className="h-8 w-24 skeleton rounded-full" /></div></div>
                                    : <QuickPick label="City" color="brand" Icon={<IoLocation />} options={cityOptions} value={values.cityId} onChange={onCity}
                                        disabled={!values.stateId} />}
                                {errors.cityId && touched.cityId && <p className='mt-1 text-red-500 text-xs'>{errors.cityId}</p>}
                            </div>
                        </div>

                        {/* Optional name search — by default chhupa, click par khule */}
                        {showName ? (
                            <div className="relative mb-3 animate-fade-up">
                                <FiSearch className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
                                <input id="searchTerm" value={values.searchTerm} onChange={handleChange} onBlur={handleBlur} autoFocus
                                    className="text-box pl-10 pr-9"
                                    placeholder={`Search by ${values.isCenter == 1 ? "Center" : "Doctor"} name...`} />
                                <button type="button" onClick={() => { setShowName(false); setValues(pre => ({ ...pre, searchTerm: "" })) }}
                                    className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                                    <IoClose />
                                </button>
                            </div>
                        ) : (
                            <button type="button" onClick={() => setShowName(true)}
                                className="inline-flex items-center gap-1.5 mb-3 text-sm font-medium text-brand-600 hover:text-brand-700">
                                <FiPlus /> Add {values.isCenter == 1 ? "center" : "doctor"} name (optional)
                            </button>
                        )}

                        {/* Main CTA */}
                        <button type="submit" disabled={!isValid || loding}
                            className={(!isValid || loding)
                                ? "btn-blue-disabled w-full flex items-center justify-center gap-2"
                                : "btn-blue w-full flex items-center justify-center gap-2 animate-fade-up"}>
                            {loding
                                ? <svg aria-hidden="true" className="w-4 h-4 animate-spin" viewBox="0 0 100 101" fill="none"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" opacity=".3" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" /></svg>
                                : <><FiSearch className="text-base" /> {isValid ? "Search now" : "Select state & city to search"}</>}
                        </button>
                    </form>
                </div>

                {/* ---- Results ---- */}
                <div className='flex flex-col justify-between grow'>
                    <section className="py-8 px-4 sm:px-6 md:px-20 bg-slate-100">
                        {loding ?
                            <LoadingContainer text={"Finding doctors"} />
                            :
                            <GlobalPaging text={values.isCenter == 1 ? "Centers" : "Doctors"} LastPage={LastPage} CurrentPage={values.pageNo} OnPageChange={OnPageChange} pagingData={pagingData} loading={loding}>
                                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                    {values.isCenter == 1 ?
                                        (centerData.length > 0
                                            ? centerData.map((item, i) => <DoctorsCard key={i} item={item.user} isCenter={true} center={item} />)
                                            : <h2 className="col-span-full text-2xl font-semibold text-center text-gray-300">No Centers Found</h2>)
                                        :
                                        (userData.length > 0
                                            ? userData.map((item, i) => <DoctorsCard key={i} item={item} />)
                                            : <h2 className="col-span-full text-2xl font-semibold text-center text-gray-300">No Doctors Found</h2>)
                                    }
                                </div>
                            </GlobalPaging>
                        }
                    </section>

                    {!IsMobileEnv && <section><Pricing /></section>}
                    <section className='h-full'><Team /></section>
                    {!IsMobileEnv ? <section><Footer /></section> : <div className='p-10 bg-white' />}
                </div>
            </div>

            <FabToggle />
        </ContainerPublic>
    )
}

function Step({ n, label, done, active }) {
    return (
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold">
            <span className={`grid place-items-center h-5 w-5 rounded-full text-[11px] ${done ? 'bg-emerald-500 text-white' : active ? 'bg-brand-500 text-white' : 'bg-gray-200 text-gray-500'}`}>
                {done ? '✓' : n}
            </span>
            <span className={done ? 'text-emerald-600' : active ? 'text-brand-600' : 'text-gray-400'}>{label}</span>
        </span>
    )
}